import { render, staticRenderFns } from "./QCol.vue?vue&type=template&id=e8987196&"
import script from "./QCol.vue?vue&type=script&lang=js&"
export * from "./QCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports